import React, { useState } from 'react'
import { Modal } from 'uiComponents/popups/modal.new'
import { ChooseDiscountType } from './chooseDiscountType'
import { DiscountCodeForm, DiscountCodeFormSchema, DiscountType } from '../_shared'
import { removeHash } from 'utils/hash'
import { showSuccessMessage } from 'uiComponents/message'
import { useAppSelector } from 'store/hooks'
import { getDiscountPools } from '../redux'
import '../_shared/modal.scss'

interface addDiscountModalProps {
    selectedPoolUuid?: string
}

export const AddDiscountModal = ({ selectedPoolUuid }: addDiscountModalProps) => {
    const [selectedDiscountType, setSelectedDiscountType] = useState<DiscountType | null>(null)
    const title = selectedDiscountType ? `Create new ${selectedDiscountType} discount` : 'Choose a discount type'
    const discountPools = useAppSelector(getDiscountPools)

    const afterSubmit = (discount: DiscountCodeFormSchema) => {
        removeHash()
        const discountPool = discountPools?.find((pool) => pool.uuid === discount.poolUuid)
        showSuccessMessage(
            `Discount "${discount.code}" created successfully${
                discountPool?.name ? ` in the "${discountPool?.name}" pool` : ''
            }`,
        )
    }

    return (
        <Modal onDismiss={removeHash} title={title} className="add-discount-modal">
            {!selectedDiscountType && <ChooseDiscountType onSelectDiscountType={setSelectedDiscountType} />}
            {selectedDiscountType && (
                <DiscountCodeForm
                    discountType={selectedDiscountType}
                    selectedPoolUuid={selectedPoolUuid}
                    onCancel={() => setSelectedDiscountType(null)}
                    afterSubmit={afterSubmit}
                />
            )}
        </Modal>
    )
}
